module.exports = __webpack_public_path__ + "img/3.87701c32.jpg";